export const MAIN_CLASS_NAME = `text-chunk`;
export const HEAD_CLASS_NAME = `${MAIN_CLASS_NAME}__head`;
export const HEAD_TOP_ROW_CLASS_NAME = `${HEAD_CLASS_NAME}__top-row`;
export const TITLE_CLASS_NAME = `${HEAD_TOP_ROW_CLASS_NAME}__title`;
export const SCORE_CLASS_NAME = `${HEAD_TOP_ROW_CLASS_NAME}__score`;
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const CONTENT_METADATA_CLASS_NAME = `${CONTENT_CLASS_NAME}__metadata`;
export const CONTENT_METADATA_KEY_CLASS_NAME = `${CONTENT_METADATA_CLASS_NAME}__key`;
export const SYSTEM_METADATA_PREFIX = 'gamma_';
export const IGNORED_METADATA_KEYS = ['window', 'url'];
export const SOURCE_TYPE_METADATA_KEY = 'source_type';
